<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <new-user-form>
          </new-user-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import NewUserForm from './UserProfile/NewUserForm.vue'

  export default {
    components: {
      NewUserForm,
    }
  }

</script>
<style>

</style>
